import { flattenServiceResponse } from "./responseFlattener";
import { isCanonicalSource } from "@/shared/mention/constants";
import { buildCanonicalFields } from "./canonicalFields";

export function normalizeRuntimeResponse(
  payload,
  { locale = "ru", participantTypeCode, serviceCode } = {}
) {
  if (!payload) return [];

  if (!participantTypeCode) {
    console.warn(
      "[normalizeRuntimeResponse] participant_type_code отсутствует — все поля будут отфильтрованы. serviceCode:",
      serviceCode
    );
  }
  if (!serviceCode) {
    console.warn(
      "[normalizeRuntimeResponse] service_code отсутствует — все поля будут отфильтрованы."
    );
  }

  const flat = flattenServiceResponse(payload, {
    locale,
    structured: false,
  });

  const fields = flat
    .map((item) => ({
      key: item.path,
      value: item.value,
      participant_type_code: participantTypeCode,
      service_code: serviceCode,
    }))
    .filter(
      (f) =>
        f.key &&
        f.value !== undefined &&
        f.value !== "" &&
        f.service_code &&
        f.participant_type_code
    );

  // Канон-поля (identifier/display_name/address) для 4 GBD-сервисов: собираем
  // из сырого ответа с локализацией и кладём в namespace "canonical".
  if (isCanonicalSource(serviceCode)) {
    fields.push(...buildCanonicalFields(payload, { participantTypeCode }));
  }

  return fields;
}
